<template>
  <header class="c_head">
    <div class="c_head_row">
      <p class="c_head_catch">サイバー犯罪に立ち向かう新たな取り組み</p>
      <a
        class="c_head_logo"
        :class="{ disabled: isReferralFlow }"
        @click="onLogoClick"
      >
        <img v-if="org && org.image" :src="org.image" height="57" alt="" />
        <img
          src="/img/cmn/img-cmnfhd-logo@2x.png"
          width="287"
          height="57"
          alt="日本サイバー犯罪対策センター"
        />
      </a>
      <div class="c_head_nav">
        <a class="c_head_nav_logout" @click="$auth.logout()">ログアウト</a>
      </div>
      <button
        id="c_head_btn"
        class="c_head_btn"
        type="button"
        v-on:click="toggleNav"
      >
        <span class="-top"></span>
        <span class="-mid"></span>
        <span class="-btm"></span>
      </button>
    </div>
    <nav id="c_spnav" class="c_spnav">
      <ul class="c_spnav_list"></ul>
      <div class="c_spnav_mypage">
        <a class="c_btn" @click="$auth.logout()">ログアウト</a>
      </div>
    </nav>
  </header>
</template>

<script>
import { globalData } from "@/global";
export default {
  computed: {
    org() {
      return globalData.org;
    },
    isReferralFlow() {
      return this.$route.path.startsWith("/referral/");
    }
  },
  methods: {
    toggleNav() {
      document.getElementById("c_head_btn").classList.toggle("-open");
      document.getElementById("c_spnav").classList.toggle("-open");
    },
    onLogoClick() {
      if (this.isReferralFlow) {
        return;
      }
      this.$router.push({ name: "Home" });
    }
  }
};
</script>

<style lang="css" scoped>
.gradient-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 14px;
  border-radius: 12px;
  border: 3px solid transparent;
  background-image: linear-gradient(to right, #36d1dc, #5b86e5);
  background-origin: border-box;
  position: relative;
  z-index: 1;
  text-decoration: none;
  transition: 0.3s;
  height: 57px;
  margin-right: 14px;
  font-weight: bold;
  color: #000;
}

.gradient-button::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-radius: 9px;
  z-index: -1;
  box-sizing: border-box;
}

.c_head_logo.disabled {
  cursor: default;
}

.c_head_catch {
  width: 320px;
}

.c_head_nav {
  width: 320px;
  text-align: right;
}
</style>
